import Box from '@mui/material/Box';

import IconoBeneficio1 from '../../assets/Imagenes/Home/IconoBenficio1.png'
import {

    Typography
} from '@mui/material';
import './styles.css';
import { Margin } from '@mui/icons-material';

const TarjetaBeneficios = ({Margin,Height,Width,Padding,ShowImagen, Imagen, ImagenAlign, ColorTarjeta, TituloContenido, TituloSize, TituloColor, TituloWeight, TituloAlign, ParrafoContenido, ParrafoSize, ParrafoColor, ParrafoWeight, ParrafoAlign }) => {

    return (
        <Box sx={{ background: ColorTarjeta,borderRadius:'12px', height:Height,width:Width,padding:Padding}}>
            <Box sx={{ margin: Margin }}>
                {
                ShowImagen !== true
                ?
                <></>
                : 
                <div style={{ display: 'flex', justifyContent: ImagenAlign}}>
                    <img src={Imagen} height='100%' alt='Icono Beneficio' style={{ margin:'40px 0px 20px 0px' }} />
                </div>                   
                }
                
                <div>
                    <Typography mb={2} pt={ShowImagen?0:2} variant="h3" sx={{ textAlign: TituloAlign, color: TituloColor, fontSize: TituloSize, fontWeight: TituloWeight }} className='itacaBlack' >
                        {TituloContenido}
                    </Typography>
                </div>
                <div>
                    <Typography sx={{ mt: 2, mb: 2, textAlign: ParrafoAlign, fontSize: ParrafoSize, color: ParrafoColor, fontSize: ParrafoSize, fontWeight: ParrafoWeight }}>
                        {ParrafoContenido}
                    </Typography>
                </div>
            </Box>
        </Box>
    );
};

export default TarjetaBeneficios;

TarjetaBeneficios.defaultProps = {
    Height:'100%',
    Width:'100%',
    ShowImagen:true,
    Padding:'0px',
    Imagen: IconoBeneficio1,
    ImagenAlign: 'flex-start',
    ColorTarjeta: 'rgba(233, 30, 99, 0.88)',
    TituloContenido: 'Contratación clara y sin complicaciones',
    TituloSize: '20px !important',
    TituloColor: 'white',
    TituloWeight: '',
    TituloAlign: 'left',
    ParrafoContenido: 'Olvídate del papeleo confuso o trámites largos. En Columba todo es transparente, digital y entendible. Te guiamos paso a paso, estés donde estés.',
    ParrafoSize: '18px !important',
    ParrafoColor: 'white',
    ParrafoWeight: '400 !important',
    ParrafoAlign: 'left',
    Margin:'10px 20px'
}